import { OnboardingV1OnboardingSurveyRole as SurveyRole } from '@spotify/confidence-graphql';

export type SurveyAnswers = {
  role?: SurveyRole;
  customRole?: string;
};

export const SURVEY_ROLE_OPTIONS: ReadonlyArray<{
  value: SurveyRole;
  label: string;
}> = [
  { value: SurveyRole.Engineering, label: 'Engineering' },
  { value: SurveyRole.DataAnalytics, label: 'Data and analytics' },
  { value: SurveyRole.ProductManagement, label: 'Product management' },
  { value: SurveyRole.DesignResearch, label: 'Design and research' },
  { value: SurveyRole.GrowthMarketing, label: 'Growth and marketing' },
  { value: SurveyRole.FounderExecutive, label: 'Founder or executive' },
];

export const MAX_CUSTOM_ROLE_LENGTH = 100;

export type OnboardingStartingPoint =
  | 'test-product-idea'
  | 'release-feature-safely'
  | 'understand-user-struggles'
  | 'explore';

export const ONBOARDING_STARTING_POINTS: ReadonlyArray<{
  id: OnboardingStartingPoint;
  label: string;
}> = [
  { id: 'test-product-idea', label: 'I want to test a product idea' },
  { id: 'release-feature-safely', label: 'I want to release a feature safely' },
  {
    id: 'understand-user-struggles',
    label: 'I want to understand where users struggle',
  },
  { id: 'explore', label: 'I’m exploring what Confidence can do' },
];
